/**
 * Content-Disposition 헤더에서 파일명을 추출한다.
 * filename*=UTF-8''... 형식을 우선 파싱하고, 없으면 filename="..." 을 사용한다.
 */
export const getFileNameFromResponse = (response, fallback = "download.xlsx") => {
  const disposition = response.headers.get("Content-Disposition");
  if (!disposition) return fallback;

  const filenameStarMatch = disposition.match(/filename\*=UTF-8''(.+)/i);
  if (filenameStarMatch) return decodeURIComponent(filenameStarMatch[1].trim());

  const filenameMatch = disposition.match(/filename="?([^";\n]+)"?/i);
  if (filenameMatch) return filenameMatch[1].trim();

  return fallback;
};

/**
 * filterMode와 filters 상태를 받아 백엔드 파라미터를 담은 URLSearchParams를 반환한다.
 * - "yearMonth" 모드: year, month 추가
 * - "dateRange" 모드: startDate, endDate 추가 (값이 있는 경우만)
 */
export const buildPayoutFilterParams = (filterMode, filters) => {
  const params = new URLSearchParams();

  if (filterMode === "yearMonth") {
    if (filters.year) params.append("year", filters.year);
    if (filters.month) params.append("month", filters.month);
  } else {
    if (filters.startDate) params.append("startDate", filters.startDate);
    if (filters.endDate) params.append("endDate", filters.endDate);
  }

  return params;
};
